import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Camera, ArrowUpRight, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import View from './View';

import work from '../../../assets/ReynoldsburgPage/Reynoldsburg_Ohio_Roofing_Contractor_Near_me_ultimatesroofing.jpg';
import work1 from '../../../assets/ReynoldsburgPage/Commercial Roof/Commercial_TPO_Roofing_Reynoldsburg_Ohio_Ultimatesroofing.webp';
import work2 from '../../../assets/ColumbusPage/Across Ohio/Healthcare_Columbus_Ohio_Project.jpg'; // fallback
import work3 from '../../../assets/ReynoldsburgPage/Commercial Roof/commercial_Metal_roofing_Reynoldsburg_Ohi_ultimatesroofing.jpg';
import work4 from '../../../assets/ColumbusPage/Across Ohio/Retail_Center_Columbus_Ohio.jpg'; // fallback
import work5 from '../../../assets/ReynoldsburgPage/Commercial Roof/Commercial_PVC_Roofing_Reynoldsburg_Ohio_ultimatesroofing.jpg';
import work6 from '../../../assets/ColumbusPage/Across Ohio/DistributionCenter_UltimatesRoofing.jpg'; // fallback
import work7 from '../../../assets/ReynoldsburgPage/Commercial Roof/Commercial_Epdm_Roofing_Reynoldsburg_Ohio_ultimatesroofing.jpg';


import '../all/Main.css';
import './Work.css';

const projects = [
  { id: 1, img: work, service: 'Best Roofing' },
  { id: 2, img: work1, service: 'TPO Reynoldsburg' },
  { id: 3, img: work2, service: 'Health Care' },
  { id: 4, img: work3, service: 'Metal Roofing' },
  { id: 5, img: work4, service: 'Retail Center' },
  { id: 6, img: work5, service: 'PVC Roofing' },
  { id: 7, img: work6, service: 'Distribution Center' },
  { id: 8, img: work7, service: 'EPDM Roofing' },
];

const WorkGallery = () => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section className="cs-section workg-section overflow-hidden" style={{backgroundColor: '#f8f9fa'}}>
      <Container>

        {/* Header Updated for Title and View Button Side-by-Side */}
        <div className="cs-title d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
          
          <motion.div
            initial={{ x: -30, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="d-flex align-items-center"
          >
            <motion.div
              className="d-flex align-items-center justify-content-center me-3 camsize"
              style={{
                width: '25px',
                height: '22px',
                borderRadius: '12px',
                flexShrink: 0,
                background: 'linear-gradient(135deg, rgba(178,35,53,0.12), rgba(178,35,53,0.05))'
              }}
            >
              <Camera className='camsize' style={{ color: '#b22335' }} />
            </motion.div>

            <h2 className="workg-title mb-0">
              Our Work <span>Across Ohio</span>
            </h2>
          </motion.div>

          {/* View Button: Mobile e End-e thakbe, Desktop e side-e */}
          <div className="d-flex justify-content-end justify-content-md-start">
            <View />
          </div>

        </div>

        {/* Description Section */}
        <p className="cs-desc workg-desc">
          We proudly deliver roofing services across Ohio, ensuring consistent quality and trusted results for every residential and commercial roofing project we complete.
        </p>

        {/* Gallery */}
        <Row className="gx-3 gy-4 cs-content">
          {projects.map((project) => {
            const isHovered = hoveredId === project.id;

            return (
              <Col xs={12} md={4} lg={3} key={project.id}>
                <motion.div
                  className="workg-card"
                  onMouseEnter={() => setHoveredId(project.id)}
                  onMouseLeave={() => setHoveredId(null)}
                  whileHover={{
                    y: -12,
                    boxShadow:
                      '0px 25px 50px rgba(178,35,53,0.18), 0px 10px 20px rgba(0,0,0,0.1)'
                  }}
                  style={{ position: 'relative', overflow: 'hidden', borderRadius: '12px' }}
                >
                  <motion.img
                    src={project.img}
                    alt={project.service}
                    className="w-100"
                    style={{
                      height: '240px',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                    animate={{
                      scale: isHovered ? 1.15 : 1,
                      filter: isHovered
                        ? 'brightness(0.55) saturate(0.7)'
                        : 'brightness(1)'
                    }}
                    transition={{ duration: 0.6 }}
                  />

                  <AnimatePresence>
                    {isHovered && (
                      <>
                        <motion.div
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          style={{
                            position: 'absolute',
                            inset: 0,
                            background:
                              'linear-gradient(180deg, rgba(178,35,53,0.0) 0%, rgba(178,35,53,0.35) 50%, rgba(0,0,0,0.75) 100%)'
                          }}
                        />

                        {/* Service Text */}
                        <div
                          style={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 5
                          }}
                        >
                          <div
                            className="workg-service-name"
                            style={{
                              color: '#fff',
                              fontSize: '1.1rem',
                              fontWeight: 700,
                              letterSpacing: '2px',
                              textTransform: 'uppercase',
                              textAlign: 'center',
                              padding: '0 10px'
                            }}
                          >
                            {project.service}
                          </div>
                        </div>

                        {/* Arrow */}
                        <div
                          style={{
                            position: 'absolute',
                            bottom: 14,
                            right: 14,
                            width: '34px',
                            height: '34px',
                            borderRadius: '50%',
                            background: '#b22335',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 6
                          }}
                        >
                          <ArrowUpRight size={16} color="#fff" />
                        </div>

                        {/* Sparkle */}
                        <div
                          style={{
                            position: 'absolute',
                            top: 14,
                            right: 14,
                            width: '30px',
                            height: '30px',
                            borderRadius: '8px',
                            background: 'rgba(255,255,255,0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 6
                          }}
                        >
                          <Sparkles size={14} color="#fff" />
                        </div>
                      </>
                    )}
                  </AnimatePresence>
                </motion.div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default WorkGallery;